export const environment = {
  production: true,
  bypassToken: '2b05da5f-8406-4592-869f-b810f97049fc',
  apiUrl: 'https://shop.dailyorders.com.au',
  mercuryApiUrl: 'https://mercury.plutocracy.io',
  storefrontKey: 'b9ee31e7e9c6d41cd3baf9857a2408bb',
  siteName: 'Daily Orders',
  siteUrl: 'https://www.dailyorders.com.au',
  storyBlokKey: 'U8ViUZEh22K3NBA9Q8qSPgtt',
  wishlistId: '66df5ef0-11e8-47c4-9b3b-099f873a576b',
};
